import customGroupsService from '../../services/customGroupsService';

export default (state, groupCode) => {
  if (!groupCode) return false;

  const customGroup = customGroupsService.urlUtils.parseUrlParam(groupCode);
  if (customGroup) {
    return { uid: groupCode, name: customGroup.name, isCustom: true };
  }

  if (!state?.fullListOfCountryGroups) return false;

  return state.fullListOfCountryGroups.find((el) => el.uid === groupCode) || false;
};
